import React from "react";
import "./App.css";
import HomePage from "./pages/Home";

function App() {
    return (
        <div className="flex bg-[var(--goat-theme-bg-white)]">
            <div className="flex-1">
                <div className="flex-1">
                    <HomePage asHomePage={true} />
                </div>
            </div>
        </div>
    );
}

export default App;
